<h1 mat-dialog-title>Copy Quote #{{data.quote_ID}}</h1>
<div mat-dialog-content>
  <p>Copying a quote creates a new quote with the same items, customer, and job information.</p>
  <form #statusForm="ngForm">
      <div class="form-group row">
        <label for="quoteCopy_Name" class="col-sm-4 col-form-label">New Quote Name</label>
        <div class="col-sm-8">
          <input class="form-control" name="quoteCopy_Name" id="quoteCopy_Name"
                  [(ngModel)]="data.quoteCopy_Name" #quoteCopy_Name="ngModel" >
        </div>
      </div>
  </form>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="data" class="btn btn-primary" cdkFocusInitial>Submit</button>
  <button mat-button (click)="onNoClick()" class="btn">Cancel</button>
</div>
